module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/prev_off-e97598d931e3dad7fec0bfe1a88ddf4f.gif";